import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = { class: "flex w-7/12 gap-x-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", { style: {"margin":"0 -16px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { class: "items-center" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Search, {
            class: "w-4/12",
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            value: _ctx.searchValue,
            placeholder: _ctx.$t('clientManagement.registrationList.searchPlaceholder')
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
          _createVNode(_component_Select, {
            dataSelect: _ctx.typeData,
            onOpenSelect: _ctx.onOpenTypeSelect,
            onCloseSelect: _ctx.onCloseTypeSelect,
            onChooseSelect: _ctx.onSelectType,
            value: _ctx.typeName,
            isOpenMenu: _ctx.typeSelect,
            class: "w-4/12 mr-2"
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"]),
          _createVNode(_component_Select, {
            dataSelect: _ctx.statusData,
            onOpenSelect: _ctx.onOpenStatusSelect,
            onCloseSelect: _ctx.onCloseStatusSelect,
            onChooseSelect: _ctx.onSelectStatus,
            value: _ctx.statusName,
            isOpenMenu: _ctx.statusSelect,
            class: "w-4/12 mr-2"
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
        ]),
        (_ctx.isCreateAble)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              onClick: _ctx.togglePanel,
              title: _ctx.$t('clientManagement.registrationList.createNewClient'),
              textColor: "white",
              customClass: "w-44",
              icon: _ctx.panelVisible ? 'chevron-up-white' : 'chevron-down-white'
            }, null, 8, ["onClick", "title", "icon"]))
          : _createCommentVNode("", true),
        _createVNode(_component_OverlayPanel, {
          ref: "op",
          appendTo: "body",
          style: {"width":"130px"},
          class: "my-panel-client-registration"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpButton, {
              onClick: _cache[1] || (_cache[1] = 
            event => {
              _ctx.goAdd('add-client-parent');
              _ctx.togglePanel(event);
            }
          ),
              flat: "",
              dense: "",
              title: _ctx.$t('clientManagement.registrationList.parentClient')
            }, null, 8, ["title"]),
            _hoisted_3,
            _createVNode(_component_LpButton, {
              onClick: _cache[2] || (_cache[2] = 
            event => {
              _ctx.goAdd('add-client-branch');
              _ctx.togglePanel(event);
            }
          ),
              flat: "",
              dense: "",
              title: _ctx.$t('clientManagement.registrationList.branchClient')
            }, null, 8, ["title"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }),
    (_ctx.isError && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.onRequest
        }, null, 8, ["errorType", "onTryAgain"]))
      : (_ctx.client.length === 0 && _ctx.firstRequest && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 1,
            data: _ctx.$t('clientManagement.registrationList.emptyData')
          }, null, 8, ["data"]))
        : (_openBlock(), _createBlock(_component_TableV2, {
            key: 2,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
            loading: _ctx.isLoading,
            columns: _ctx.columns,
            data: _ctx.client,
            sortBy: _ctx.orderBy,
            sortDirection: _ctx.sortDirection,
            class: "my-2",
            paginationStyle: "v3",
            pinnedSubstractHeight: "290px",
            onRequest: _ctx.onRequest,
            onSort: _ctx.onSort,
            onClick: _ctx.onClickRow,
            isDetailAble: _ctx.isDetailAble,
            "data-testid": "client-registration-table-v2"
          }, null, 8, ["pagination", "loading", "columns", "data", "sortBy", "sortDirection", "onRequest", "onSort", "onClick", "isDetailAble"]))
  ]))
}